import { isSearchModel, SearchModel } from '#pplx/frontend/ask-models/types/search-modes.js';
/*
 * Maps keywords to search models for marketing purposes.
 * this mostly exists for backwards compatibility for the model_id query parameter which use to have a special mapping ThreadSettingsProvider that was moved here
 */
const keywords = {
    deep_research: SearchModel.ALPHA,
};
export const getSearchModelForQModel = (modelValue) => {
    const modelForKeyword = keywords[modelValue.toLowerCase()];
    if (modelForKeyword) {
        return modelForKeyword;
    }
    if (isSearchModel(modelValue)) {
        return modelValue;
    }
    return undefined;
};
//# sourceMappingURL=getSearchModelForQModel.js.map